import styles from "../../../styles/FormSummary.module.css"
import previewStyles from "../../../styles/FilePreview.module.css"
import { useFirebaseFileUrl } from "../../../hooks/useFirebaseFileUrl"

export default function FilePreview({ path, fieldType }) {
  const { url, loading, error } = useFirebaseFileUrl(path)

  if (loading) {
    return <div className={styles.summaryFieldValueLine}>Loading preview...</div>
  }

  if (error) {
    return <div className={styles.summaryFieldValueLine}>Could not load preview.</div>
  }

  if (!url) {
    return null // Or some placeholder if you prefer
  }

  const fileName = path.split(/[/\\]/).pop()

  if (fieldType === "file_image") {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" title={fileName}>
        <img src={url} alt="File preview" className={previewStyles.previewImage} />
      </a>
    )
  }

  if (fieldType === "file") {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" title={fileName}>
        <i className={`pi pi-file-pdf ${previewStyles.documentIcon}`}></i>
      </a>
    )
  }

  // Fallback for other file types or when fieldType is not provided
  return <div className={styles.summaryFieldValueLine}>{fileName || "File"}</div>
}